'use es6';

import { Map as ImmutableMap } from 'immutable';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LS_SOURCE_OF_CURRENT_DRAG } from 'ContentEditorUI/lib/layoutSection/dom';
import { getDndAreaElementForNode } from 'layout-dnd-utils/dom/dndAreaDomSelectors';
import { getCurrentDragItem } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { getAllLayoutSectionTreesAsMap } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getImmutableOrPlain } from 'ContentEditorUI/utils/dataHelpers';
const mapStateToProps = state => {
  return {
    currentDragItem: getCurrentDragItem(state),
    allTreesByName: getAllLayoutSectionTreesAsMap(state)
  };
};
class LayoutSectionDragDomManipulationContainer extends Component {
  componentDidUpdate(prevProps) {
    const {
      currentDragItem
    } = this.props;
    if (prevProps.currentDragItem !== currentDragItem) {
      if (this.isValidDragItemFromDocument(prevProps.currentDragItem)) {
        this.removeSourceOfCurrentDragClassname(prevProps.currentDragItem);
      }
      if (this.isValidDragItemFromDocument(currentDragItem)) {
        this.addSourceOfCurrentDragClassname(currentDragItem);
      }
    }
  }
  isValidDragItemFromDocument(dragItem) {
    return dragItem && getImmutableOrPlain(dragItem, 'dragId') && !getImmutableOrPlain(dragItem, 'fromInpageSidebar', false);
  }
  getRowOrColumnElementFromDragItem(dragItem, tree) {
    const node = getImmutableOrPlain(dragItem, 'isRow') ? tree.findRow(getImmutableOrPlain(dragItem, 'dragId')) : tree.findCell(getImmutableOrPlain(dragItem, 'dragId'));
    return getDndAreaElementForNode(node);
  }
  removeSourceOfCurrentDragClassname(dragItem) {
    const {
      allTreesByName
    } = this.props;
    const originTree = allTreesByName[getImmutableOrPlain(dragItem, 'originLayoutSectionId')];
    this.getRowOrColumnElementFromDragItem(dragItem, originTree).classList.remove(LS_SOURCE_OF_CURRENT_DRAG);
  }
  addSourceOfCurrentDragClassname(dragItem) {
    const {
      allTreesByName
    } = this.props;
    const originTree = allTreesByName[getImmutableOrPlain(dragItem, 'originLayoutSectionId')];
    this.getRowOrColumnElementFromDragItem(dragItem, originTree).classList.add(LS_SOURCE_OF_CURRENT_DRAG);
  }
  render() {
    return null;
  }
}
LayoutSectionDragDomManipulationContainer.propTypes = {
  currentDragItem: PropTypes.oneOfType([PropTypes.instanceOf(ImmutableMap), PropTypes.object]),
  allTreesByName: PropTypes.object.isRequired
};
export default connect(mapStateToProps)(LayoutSectionDragDomManipulationContainer);